export const CONTINUOUS_SECTION_TEST_ID = "continuous-section";
